import { useCallback, useState } from 'react';
import { ProcessingEstimating } from './processing-estimating';
import { ProcessingResults } from './processing-results';

interface ProcessingFlowProps {
  onContinue: () => void;
}

export function ProcessingFlow({ onContinue }: ProcessingFlowProps) {
  const [step, setStep] = useState<'estimating' | 'results'>('estimating');

  const handleEstimatingComplete = useCallback(() => {
    setStep('results');
  }, []);

  if (step === 'results') {
    return <ProcessingResults onContinue={onContinue} />;
  }

  return <ProcessingEstimating onComplete={handleEstimatingComplete} />;
}
